import {TtWorkingTimeType} from '../../interfaces/time-tracking/tt-working-time-type';


export class TtWorkingTimeTypeFactory {

  /**
   *
   * @param ttWorkingTimeType
   */
  public static fromObject(ttWorkingTimeType: any): TtWorkingTimeType {
    return new class implements TtWorkingTimeType {
      color: string = ttWorkingTimeType.color;
      customId: number = ttWorkingTimeType.custom_id;
      description: string = ttWorkingTimeType.description;
      id: number = ttWorkingTimeType.id;
      isInCalculation: boolean = ttWorkingTimeType.is_in_calculation;
      isStandby: boolean = ttWorkingTimeType.is_standby;
      name: string = ttWorkingTimeType.name;
      shortName: string = ttWorkingTimeType.short_name;
      sort: number = ttWorkingTimeType.sort;
      userRights: number = ttWorkingTimeType.user_rights;
    };
  }

  /**
   *
   * @param ttWorkingTimeType
   */
  public static fromArray(ttWorkingTimeType: any[]): TtWorkingTimeType[] {
    return ttWorkingTimeType.map((_ttWorkingTimeType) => this.fromObject(_ttWorkingTimeType));
  }


}

